export default __webpack_public_path__ + "static/media/home.34f3d0ad.webp";